import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
interface ResultsViewStyles {
  container: ICSSInJSStyle;
}

export const useResultsViewStyles: () => ResultsViewStyles = () => {
  const { main } = useFluentColorScheme();
  const screenHeight = window.document.documentElement.clientHeight;

  return {
    container: {
      background: main.background2,
      width: "100%",
      height: screenHeight + "px",
      overflow: "scroll",
    },
  };
};
